











































































































































































































































































// 3rd party libs
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Components
import loadingSpinner from '@webapp/components/loading-spinner/loading-spinner.vue';
import backButton from '@webapp/components/back-button/back-button.vue';
import nftDisplay from '@webapp/modules/crypto-and-trading/views/nft/nft-display.vue';

// Shared Modules
import {
    EventNames,
} from '@shared/utils/analytics-keys';

// Helpers
import {
    copyToClipboard,
} from '@webapp/helpers/generic.js';
import walletButtons from '@webapp/helpers/wallet-navigation.js';

export default {
    name: 'nft-details',
    components: {
        loadingSpinner,
        backButton,
        nftDisplay,
    },
    data() {
        return {
            isLoading: true,
            collectibleId: this.$route.params.collectibleId,
        };
    },
    computed: {
        ...mapGetters([
            'isPartnerApp',
            'userId',
            'partnerAppData',
            'isARLocale',
        ]),

        ...mapGetters('nfts', [
            'getNftFormattedDetailsById',
            'nftRecipients',
        ]),

        nftTitle() {
            return this.nft.partnerName || this.$t('nft.details.digitalCollectible');
        },

        nft() {
            return this.getNftFormattedDetailsById(this.collectibleId) || {};
        },

        withdrawButton() {
            return walletButtons.find((item) => item.name === 'send');
        },

        blockchainIconPath() {
            return this.nft.networkType ? require(`@webapp/assets/${this.nft.networkType}.svg`) : '';
        },

        getNftUrl() {
            return this.nft.animationUrl || this.nft.imageUrl;
        },

        isVideo() {
            return this.nft.animationUrl !== '';
        },

        infoAlignment() {
            return this.isARLocale ? 'right' : 'left';
        },
    },
    mounted() {
        this.checkPartnerApp();
        this.initNFTs();
        // eslint-disable-next-line no-console
        console.log('Teste', this.isARLocale);
    },
    methods: {
        ...mapActions('nfts', ['fetchDetailsNFT']),

        checkPartnerApp() {
            if (this.isPartnerApp) {
                this.$webTrackingInstance?.sendEvent(
                    EventNames.PartnerDigitalCol,
                    [
                        {
                            key: 'partner',
                            value: this.partnerAppData.id,
                        },
                        {
                            key: 'user',
                            value: this.userId,
                        },
                        {
                            key: 'from',
                            value: 'wallet',
                        },
                    ]
                );
                this.$router.push('/digital-collectibles');
            }
        },

        async initNFTs() {
            await this.fetchDetailsNFT({
                collectibleId: this.collectibleId,
            });

            this.isLoading = false;
        },

        onItemTap(item) {
            if (item.isCopyable && item.value) {
                copyToClipboard(item.value, this);
            }
        },

        onClickGoToTransferNfts() {
            this.$router.push({
                name: 'digitalCollectiblesWithdraw',
                params: {
                    collectibleId: this.collectibleId,
                    nft: this.nft,
                },
            });
        },
    },
};
